import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { getAllUsers } from '~/api';
import PageTitle from '~/components/PageTitle';
import Loading from '~/components/Loading';
import List from '~/components/List';

const StyledList = styled(List)`
  margin-bottom: 20px;
`;

function Users() {
  const [users, setUsers] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  const onUserClick = (user) =>
    history.push(`/users/${user.id}/training-routines`);

  const getUsers = async () => {
    try {
      const { data: allUsers } = await getAllUsers();

      setUsers(allUsers);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (event) => {
    const { value } = event.target;
    if (typeof value !== 'string') return;
    setSearchValue(value);
  };

  useEffect(() => {
    getUsers();
  }, []);

  const usersList = users.map((user) => ({
    id: user.id,
    title: user.name,
  }));

  return (
    <>
      <PageTitle>Lista de alunos</PageTitle>
      {!isLoading ? (
        <StyledList
          items={usersList}
          emptyText="Nenhum aluno"
          onClick={onUserClick}
          searchValue={searchValue}
          onChange={handleSearchChange}
        />
      ) : (
        <Loading />
      )}
    </>
  );
}

export default Users;
